var _defs, _metadata, _g, _g2, _rect, _path, _g3, _path2, _path3, _g4, _path4, _path5, _g5, _path6, _g6, _circle, _g7, _circle2, _circle3, _circle4, _path7, _path8, _path9, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAni20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "77.2523mm",
    height: "62.5082mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3946 3193",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str0 {stroke:black;stroke-width:90.0867}\r\n    .str1 {stroke:black;stroke-width:90.0867;stroke-linecap:round}\r\n    .str2 {stroke:black;stroke-width:90.0867;stroke-linecap:round;stroke-linejoin:bevel}\r\n    .fil2 {fill:none}\r\n    .fil7 {fill:black}\r\n    .fil1 {fill:#B06337}\r\n    .fil3 {fill:#B6420D}\r\n    .fil0 {fill:#EECD8A}\r\n    .fil6 {fill:white}\r\n    .fil5 {fill:black;fill-rule:nonzero}\r\n    .fil4 {fill:white}\r\n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3666 1131c-197,183 -586,121 -843,62 -203,-48 -304,223 -294,32 15,-287 784,-386 1137,-94z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279 1131c197,183 587,121 843,62 203,-48 304,223 295,32 -15,-287 -785,-386 -1138,-94z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1973 596c-127,-2 -860,25 -1281,933 -510,1098 443,1234 1281,1234 836,-2 1791,-134 1280,-1234 -421,-908 -1154,-935 -1280,-933z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_650648336"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "fil0 str0",
    x: 1080,
    y: 476,
    width: 179,
    height: 641
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil1 str0",
    cx: 1170,
    cy: 460,
    r: 182
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "fil0 str0",
    x: 2658,
    y: 476,
    width: 179,
    height: 641
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil1 str0",
    cx: 2748,
    cy: 460,
    r: 182
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    width: 3946,
    height: 3193
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M3666 1131c-197,183 -586,121 -843,62 -203,-48 -304,223 -294,32 15,-287 784,-386 1137,-94z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil3",
    d: "M3086 1012c24,-76 135,-132 196,-78 73,65 -15,207 -116,201 -51,-3 -101,-55 -80,-123z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M3594 1105c-48,-78 -127,-115 -206,-84 -60,23 7,128 76,147 58,16 167,-4 130,-63z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M3666 1131c-197,183 -586,121 -843,62 -203,-48 -304,223 -294,32 15,-287 784,-386 1137,-94z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M279 1131c197,183 587,121 843,62 203,-48 304,223 295,32 -15,-287 -785,-386 -1138,-94z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id1)"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil3",
    d: "M400 1072c5,-78 98,-160 170,-123 88,46 37,205 -62,224 -50,9 -112,-28 -108,-101z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M929 971c-66,-64 -151,-81 -221,-32 -52,38 39,124 110,125 61,2 161,-45 111,-93z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M279 1131c197,183 587,121 843,62 203,-48 304,223 295,32 -15,-287 -785,-386 -1138,-94z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1973 596c-127,-2 -860,25 -1281,933 -510,1098 443,1234 1281,1234 836,-2 1791,-134 1280,-1234 -421,-908 -1154,-935 -1280,-933z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id2)"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil3",
    d: "M2448 1233c34,-28 34,-78 34,-118 -2,-144 -203,-219 -323,-110 -154,141 73,409 289,228z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M709 2472c34,-33 35,-91 34,-139 -2,-167 -202,-255 -323,-127 -154,164 73,477 289,266z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M3422 2170c-41,24 -97,10 -142,-3 -162,-45 -194,-262 -40,-345 199,-106 442,194 182,348z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M1183 1318c114,101 352,15 362,-119 29,-394 -567,-62 -362,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M2560 923c116,76 344,50 380,-75 43,-152 -241,-257 -388,-159 -75,50 -97,163 8,234z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M3173 2358c57,134 -32,347 -183,344 -182,-4 -227,-311 -78,-423 75,-57 209,-45 261,79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M1786 1066c112,47 238,-5 273,-101 36,-100 -63,-182 -160,-213 -57,-17 -148,-8 -175,37 -64,106 -61,226 62,277z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M1422 851c151,118 330,-126 231,-241 -75,-87 -477,49 -231,241z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M1910 1539c137,23 259,-174 138,-236 -326,-166 -374,197 -138,236z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M2647 1075c97,-86 329,17 271,126 -158,296 -438,21 -271,-126z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M908 2287c97,-100 329,20 271,148 -158,345 -438,24 -271,-148z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M3322 2314c-122,68 -66,323 73,300 374,-63 137,-417 -73,-300z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M1003 1131c191,-32 255,-193 115,-335 -42,-43 -71,90 -111,139 -57,69 -250,238 -4,196z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M2429 670c-19,-101 -60,-119 -146,-109 -63,8 -154,146 -95,220 95,122 249,-69 241,-111z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M820 1815c-19,-118 -60,-139 -146,-127 -63,9 -154,170 -95,256 95,142 249,-80 241,-129z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M1973 1946c-191,0 -346,197 -346,441 0,244 155,441 346,441 191,0 346,-197 346,-441 0,-244 -155,-441 -346,-441z"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M1973 596c-127,-2 -860,25 -1281,933 -510,1098 443,1234 1281,1234 836,-2 1791,-134 1280,-1234 -421,-908 -1154,-935 -1280,-933z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M1738 1854l-180 0 0 0 0 -9 0 -8 -1 -8 -1 -7 -2 -8 -2 -7 -2 -8 -3 -7 -3 -6 -3 -7 -3 -7 -4 -6 -4 -6 -4 -5 -4 -6 -4 -5 -5 -5 -5 -4 -5 -5 -5 -4 -5 -3 -6 -4 -5 -3 -6 -3 -5 -2 -6 -2 -6 -2 -6 -1 -6 -2 -6 0 -6 -1 -6 0 0 -180 16 0 16 1 16 3 15 3 16 4 15 4 15 6 14 6 14 7 13 7 13 9 13 8 12 10 11 10 12 10 10 12 10 11 10 12 9 13 8 13 8 13 7 14 7 14 6 14 5 15 5 15 4 16 3 16 3 16 1 16 2 16 0 17 0 0zm-309 331l0 -180 0 0 6 -1 6 0 6 -1 6 -1 6 -2 6 -1 6 -3 5 -2 6 -3 5 -3 6 -3 5 -4 5 -4 5 -4 5 -5 5 -5 4 -5 4 -5 4 -6 4 -6 4 -6 3 -6 3 -7 3 -7 3 -7 2 -7 2 -8 2 -7 1 -8 1 -8 0 -8 0 -8 180 0 0 16 -2 17 -1 16 -3 16 -3 16 -4 15 -5 15 -5 15 -6 14 -7 15 -7 13 -8 14 -8 13 -9 12 -10 12 -10 12 -10 11 -12 11 -11 10 -12 9 -13 9 -13 8 -13 8 -14 7 -14 6 -15 5 -15 5 -16 4 -15 3 -16 2 -16 1 -16 1 0 0zm-310 -331l180 0 0 0 0 8 1 8 1 8 1 8 1 7 2 8 3 7 2 7 3 7 3 7 3 6 4 6 4 6 4 6 4 5 5 5 4 5 5 5 5 4 5 4 5 4 6 3 5 3 6 3 6 2 5 3 6 1 6 2 6 1 6 1 6 0 7 1 0 180 -17 -1 -16 -1 -16 -2 -15 -3 -16 -4 -15 -5 -14 -5 -14 -6 -14 -7 -14 -8 -13 -8 -12 -9 -13 -9 -11 -10 -11 -11 -11 -11 -10 -12 -9 -12 -9 -12 -9 -13 -8 -14 -7 -13 -6 -15 -6 -14 -6 -15 -4 -15 -4 -15 -4 -16 -2 -16 -2 -16 -1 -17 -1 -16 0 0zm310 -331l0 180 0 0 -7 0 -6 1 -6 0 -6 2 -6 1 -6 2 -5 2 -6 2 -6 3 -5 3 -6 4 -5 3 -5 4 -5 5 -5 4 -4 5 -5 5 -4 6 -4 5 -4 6 -4 6 -3 7 -3 7 -3 6 -2 7 -3 8 -2 7 -1 8 -1 7 -1 8 -1 8 0 9 -180 0 1 -17 1 -16 2 -16 2 -16 4 -16 4 -16 4 -15 6 -15 6 -14 6 -14 7 -14 8 -13 9 -13 9 -13 9 -12 10 -11 11 -12 11 -10 11 -10 13 -10 12 -8 13 -9 14 -7 14 -7 14 -6 14 -6 15 -4 16 -4 15 -3 16 -3 16 -1 17 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil6",
    d: "M1429 1613c121,0 219,108 219,241 0,133 -98,241 -219,241 -122,0 -220,-108 -220,-241 0,-133 98,-241 220,-241z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil7",
    cx: 1489,
    cy: 1857,
    r: 199
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M2208 1854l0 0 0 -17 1 -16 2 -16 3 -16 3 -16 4 -16 5 -15 5 -15 6 -14 7 -14 7 -14 8 -13 8 -13 9 -13 9 -12 11 -11 10 -12 11 -10 12 -10 12 -10 13 -8 13 -9 13 -7 14 -7 14 -6 15 -6 15 -4 15 -4 16 -3 16 -3 16 -1 16 0 0 180 -6 0 -7 1 -6 0 -6 2 -6 1 -5 2 -6 2 -6 2 -5 3 -6 3 -5 4 -5 3 -5 4 -5 5 -5 4 -5 5 -4 5 -5 6 -4 5 -4 6 -3 6 -4 7 -3 7 -3 6 -2 7 -2 8 -2 7 -2 8 -1 7 -1 8 -1 8 0 9 0 0 -179 0zm309 331l0 0 -16 -1 -16 -1 -16 -2 -16 -3 -15 -4 -15 -5 -15 -5 -14 -6 -14 -7 -13 -8 -13 -8 -13 -9 -12 -9 -12 -10 -11 -11 -10 -11 -11 -12 -9 -12 -9 -12 -8 -13 -8 -14 -7 -13 -7 -15 -6 -14 -5 -15 -5 -15 -4 -15 -3 -16 -3 -16 -2 -16 -1 -17 0 -16 179 0 0 8 1 8 1 8 1 8 2 7 2 8 2 7 2 7 3 7 3 7 4 6 3 6 4 6 4 6 5 5 4 5 5 5 5 5 5 4 5 4 5 4 5 3 6 3 5 3 6 2 6 3 5 1 6 2 6 1 6 1 7 0 6 1 0 0 0 180zm309 -331l0 0 0 16 -1 17 -2 16 -3 16 -3 16 -4 15 -5 15 -5 15 -6 14 -7 15 -7 13 -8 14 -8 13 -9 12 -9 12 -10 12 -11 11 -11 11 -12 10 -12 9 -12 9 -13 8 -14 8 -14 7 -14 6 -15 5 -15 5 -15 4 -16 3 -16 2 -16 1 -16 1 0 -180 6 -1 7 0 6 -1 6 -1 6 -2 5 -1 6 -3 6 -2 5 -3 6 -3 5 -3 5 -4 6 -4 5 -4 4 -5 5 -5 4 -5 5 -5 4 -6 4 -6 3 -6 4 -6 3 -7 3 -7 2 -7 2 -7 2 -8 2 -7 1 -8 1 -8 1 -8 0 -8 0 0 179 0zm-309 -331l0 0 16 0 16 1 16 3 16 3 15 4 15 4 15 6 14 6 14 7 14 7 13 9 12 8 12 10 12 10 11 10 11 12 10 11 9 12 9 13 8 13 8 13 7 14 7 14 6 14 5 15 5 15 4 16 3 16 3 16 2 16 1 16 0 17 -179 0 0 -9 -1 -8 -1 -8 -1 -7 -2 -8 -2 -7 -2 -8 -2 -7 -3 -6 -3 -7 -4 -7 -3 -6 -4 -6 -4 -5 -5 -6 -4 -5 -5 -5 -4 -4 -5 -5 -6 -4 -5 -3 -5 -4 -6 -3 -5 -3 -6 -2 -6 -2 -5 -2 -6 -1 -6 -2 -6 0 -7 -1 -6 0 0 0 0 -180z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil6",
    d: "M2517 1613c-121,0 -220,108 -220,241 0,133 99,241 220,241 121,0 220,-108 220,-241 0,-133 -99,-241 -220,-241z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "fil7",
    cx: 2456,
    cy: 1857,
    r: 199
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "fil6",
    cx: 2397,
    cy: 1856,
    r: 78
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "fil6",
    cx: 1549,
    cy: 1856,
    r: 78
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str1",
    d: "M1972 2336c0,65 4,131 0,195 -7,96 -217,110 -229,-63"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str1",
    d: "M1974 2336c0,65 -5,131 0,195 7,96 216,110 229,-63"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str2",
    d: "M2175 2198l-102 52m-199 0l-103 -51"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    d: "M2571 1536c165,46 182,61 320,-29 -38,62 -82,113 -196,126 111,38 156,45 265,-33 -54,103 -119,127 -188,129 77,51 133,48 202,3 -45,68 -111,103 -190,72 -60,-132 -113,-172 -213,-268z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    d: "M1374 1536c-165,46 -181,61 -319,-29 38,62 81,113 196,126 -111,38 -156,45 -265,-33 54,103 119,127 188,129 -78,51 -134,48 -203,3 45,68 111,103 191,72 60,-132 113,-172 212,-268z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni20);
export default __webpack_public_path__ + "static/media/ani20.3071a6a647334733591f7830359fff73.svg";
export { ForwardRef as ReactComponent };